module.exports = __webpack_public_path__ + "a58eadd484ad7eba30c55f0d7905d93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/images/2016_prp_circle.png
// module id = 389
// module chunks = 0